// extracted by mini-css-extract-plugin
export default {"img":"IconImg_img_GV74V"};